import { render, staticRenderFns } from "./WarningData.vue?vue&type=template&id=ed863022&scoped=true"
import script from "./WarningData.vue?vue&type=script&lang=js"
export * from "./WarningData.vue?vue&type=script&lang=js"
import style0 from "./WarningData.vue?vue&type=style&index=0&id=ed863022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed863022",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalWarningOption: require('/home/vsts/work/1/s/components/global/WarningOption.vue').default})
